export default "__VITE_ASSET__BKBet8Ns__"